<div [hidden]="showSpinner">
  @for(question of questionListResponsponse.oowQuestion; track index; let index = $index; let first = $first){
  <fieldset [class.bl-margin-top--32]="!first">
    <legend class="bl-label bl-font-weight--800 bl-required" [attr.aria-describedby]="'desc-' + question.relativeOrder">
      {{ question.questionText }}
    </legend>
    <div>
      <div class="bl-check-wrap">
        @for(questionChoice of question.questionChoices; track optionIndex; let optionIndex = $index){
        <div class="bl-margin-top--8"
          [ngClass]="{ 'bl-validation-error': !question.answer && (pageSubmitted$ | async) }">
          <!-- [name] and [attr.name] are needed for Angular grouping logic -->
          <input type="radio" (change)="preciseIdAnsersSelection()" [id]="'question-'+index+'-choice-'+optionIndex"
            [(ngModel)]="questionListResponsponse.oowQuestion[index].answer" [value]="questionChoice.questionChoiceId"
            [name]="'question-'+index" [attr.name]="'question-'+index"
            [attr.data-automation-id]="'questionChoice' + questionChoice.questionChoiceId" required #radioGroup />
          <label class="bl-label" [for]="'question-'+index+'-choice-'+optionIndex">
            {{ questionChoice.questionChoiceText }}
          </label>
        </div>
        }
        <span [id]="'desc-' + question.relativeOrder" role="alert"
          *ngIf="!questionListResponsponse.oowQuestion[index].answer && (pageSubmitted$ | async)"
          class="bl-error-msg bl-margin-right--16">This is a required field</span>
      </div>
    </div>
  </fieldset>
  }
</div>
<ecp-content-spinner [hidden]="!showSpinner"></ecp-content-spinner>
